import React from "react";

const Aspire = () => {
  const iframeSrc = (() => {
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ["utm_source", "utm_medium", "utm_campaign"];
    const utmParams = new URLSearchParams();
    utmKeys.forEach((k) => { if (params.has(k)) utmParams.set(k, params.get(k)); });
    const qs = utmParams.toString();
    return qs ? `/aspire.html?${qs}` : "/aspire.html";
  })();

  return (
    <div
      style={{
        margin: "0px",
        padding: "0px",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <iframe
        src={iframeSrc}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="HTML Renderer"
      />
    </div>
  );
};

export default Aspire;
